import { createQueryParams, handleAPIResponse } from '@/@shared/api/handlers/apiResponse';
import { contentFetcher } from '@/model/openAPI/content-server/instance';
import {
	TournamentV2Controller_getSignedUrl_Params,
	TournamentV2Controller_getSignedUrl_Body,
	TournamentV2Controller_getSignedUrl_Response,
	TournamentV2Controller_getSignedUrl_RO,
	TournamentV2Controller_holdTournament_Params,
	TournamentV2Controller_holdTournament_Body,
	TournamentV2Controller_holdTournament_Response,
	TournamentV2Controller_holdTournament_RO,
	TournamentV2Controller_applyHoldTournament_Params,
	TournamentV2Controller_applyHoldTournament_Body,
	TournamentV2Controller_applyHoldTournament_Response,
	TournamentV2Controller_applyHoldTournament_RO,
	TournamentV2Controller_getAppliedTournaments_Params,
	TournamentV2Controller_getAppliedTournaments_Response,
	TournamentV2Controller_getAppliedTournaments_RO,
	TournamentV2Controller_getMySetupTournaments_Params,
	TournamentV2Controller_getMySetupTournaments_Response,
	TournamentV2Controller_getMySetupTournaments_RO,
	TournamentV2Controller_getMyProgressTournaments_Params,
	TournamentV2Controller_getMyProgressTournaments_Response,
	TournamentV2Controller_getMyProgressTournaments_RO,
	TournamentV2Controller_getMyFinishedTournaments_Params,
	TournamentV2Controller_getMyFinishedTournaments_Response,
	TournamentV2Controller_getMyFinishedTournaments_RO,
	TournamentV2Controller_getIncompleteTournamentDetail_Params,
	TournamentV2Controller_getIncompleteTournamentDetail_Response,
	TournamentV2Controller_getIncompleteTournamentDetail_RO,
	TournamentV2Controller_completeSetupTournament_Params,
	TournamentV2Controller_completeSetupTournament_Body,
	TournamentV2Controller_completeSetupTournament_Response,
	TournamentV2Controller_getTournamentDancesForWeb_Params,
	TournamentV2Controller_getTournamentDancesForWeb_Response,
	TournamentV2Controller_getTournamentDancesForWeb_RO,
	TournamentV2Controller_getTournamentLocalizations_Params,
	TournamentV2Controller_getTournamentLocalizations_Response,
	TournamentV2Controller_getTournamentLocalizations_RO,
	TournamentV2Controller_getTournamentBanners_Params,
	TournamentV2Controller_getTournamentBanners_Response,
	TournamentV2Controller_getTournamentBanners_RO,
	TournamentV2Controller_getUserFilterStatistics_Params,
	TournamentV2Controller_getUserFilterStatistics_Response,
	TournamentV2Controller_getUserFilterStatistics_RO,
	TournamentV2Controller_getManageRegisterTournament_Params,
	TournamentV2Controller_getManageRegisterTournament_Response,
	TournamentV2Controller_getManageRegisterTournament_RO,
	TournamentV2Controller_getManageQaulifierTournament_Params,
	TournamentV2Controller_getManageQaulifierTournament_Response,
	TournamentV2Controller_getManageQaulifierTournament_RO,
	TournamentV2Controller_getManageSelectingTournament_Params,
	TournamentV2Controller_getManageSelectingTournament_Response,
	TournamentV2Controller_getManageSelectingTournament_RO,
	TournamentV2Controller_getManageSelectingNoneTournament_Params,
	TournamentV2Controller_getManageSelectingNoneTournament_Response,
	TournamentV2Controller_getManageSelectingNoneTournament_RO,
	TournamentV2Controller_getManageSelectingSelectedTournament_Params,
	TournamentV2Controller_getManageSelectingSelectedTournament_Response,
	TournamentV2Controller_getManageSelectingSelectedTournament_RO,
	TournamentV2Controller_getManageSelectingMatchedTournament_Params,
	TournamentV2Controller_getManageSelectingMatchedTournament_Response,
	TournamentV2Controller_getManageSelectingMatchedTournament_RO,
	TournamentV2Controller_selectNominees_Params,
	TournamentV2Controller_selectNominees_Body,
	TournamentV2Controller_selectNominees_Response,
	TournamentV2Controller_matchTournament_Params,
	TournamentV2Controller_matchTournament_Body,
	TournamentV2Controller_matchTournament_Response,
	TournamentV2Controller_getManagePrematchTournament_Params,
	TournamentV2Controller_getManagePrematchTournament_Response,
	TournamentV2Controller_getManagePrematchTournament_RO,
	TournamentV2Controller_getManageLiveTournament_Params,
	TournamentV2Controller_getManageLiveTournament_Response,
	TournamentV2Controller_getManageLiveTournament_RO,
	TournamentV2Controller_getManageFinishedTournament_Params,
	TournamentV2Controller_getManageFinishedTournament_Response,
	TournamentV2Controller_getManageFinishedTournament_RO,
	TournamentV2Controller_mappingUpcommingTournamentDance_Params,
	TournamentV2Controller_mappingUpcommingTournamentDance_Body,
	TournamentV2Controller_mappingUpcommingTournamentDance_Response,
	TournamentV2Controller_registerNotification_Params,
	TournamentV2Controller_registerNotification_Body,
	TournamentV2Controller_registerNotification_Response,
	TournamentV2Controller_getRegisterNotificationStatus_Params,
	TournamentV2Controller_getRegisterNotificationStatus_Response,
	TournamentV2Controller_getRegisterNotificationStatus_RO,
	TournamentV2Controller_joinTournament_Params,
	TournamentV2Controller_joinTournament_Body,
	TournamentV2Controller_joinTournament_Response,
	TournamentV2Controller_cancelJoinTournament_Params,
	TournamentV2Controller_cancelJoinTournament_Body,
	TournamentV2Controller_cancelJoinTournament_Response,
	TournamentV2Controller_applyTournament_Params,
	TournamentV2Controller_applyTournament_Body,
	TournamentV2Controller_applyTournament_Response,
	TournamentV2Controller_cancelApplyTournament_Params,
	TournamentV2Controller_cancelApplyTournament_Body,
	TournamentV2Controller_cancelApplyTournament_Response,
	TournamentV2Controller_getTournamentParticipants_Params,
	TournamentV2Controller_getTournamentParticipants_Response,
	TournamentV2Controller_getTournamentParticipants_RO,
	TournamentV2Controller_getTournamentApplicants_Params,
	TournamentV2Controller_getTournamentApplicants_Response,
	TournamentV2Controller_getTournamentApplicants_RO,
	TournamentV2Controller_getTournamentNominees_Params,
	TournamentV2Controller_getTournamentNominees_Response,
	TournamentV2Controller_getTournamentNominees_RO,
	TournamentV2Controller_getRoundParticipants_Params,
	TournamentV2Controller_getRoundParticipants_Response,
	TournamentV2Controller_getRoundParticipants_RO,
	TournamentV2Controller_getRoundMatches_Params,
	TournamentV2Controller_getRoundMatches_Response,
	TournamentV2Controller_getRoundMatches_RO,
	TournamentV2Controller_getTournamentRounds_Params,
	TournamentV2Controller_getTournamentRounds_Response,
	TournamentV2Controller_getTournamentRounds_RO,
	TournamentV2Controller_getTournamentDances_Params,
	TournamentV2Controller_getTournamentDances_Response,
	TournamentV2Controller_getTournamentDances_RO,
	TournamentV2Controller_getTournamentNations_Params,
	TournamentV2Controller_getTournamentNations_Response,
	TournamentV2Controller_getTournamentNations_RO,
	TournamentV2Controller_processApplicant_Params,
	TournamentV2Controller_processApplicant_Body,
	TournamentV2Controller_processApplicant_Response,
	TournamentV2Controller_inviteTournament_Params,
	TournamentV2Controller_inviteTournament_Body,
	TournamentV2Controller_inviteTournament_Response,
	TournamentV2Controller_modifyTournamentInvite_Params,
	TournamentV2Controller_modifyTournamentInvite_Body,
	TournamentV2Controller_modifyTournamentInvite_Response,
	TournamentV2Controller_getTournamentInvites_Params,
	TournamentV2Controller_getTournamentInvites_Response,
	TournamentV2Controller_getTournamentInvites_RO,
	TournamentV2Controller_cancelTournamentInvite_Params,
	TournamentV2Controller_cancelTournamentInvite_Body,
	TournamentV2Controller_cancelTournamentInvite_Response,
	TournamentV2Controller_kickParticipant_Params,
	TournamentV2Controller_kickParticipant_Body,
	TournamentV2Controller_kickParticipant_Response,
	TournamentV2Controller_kickNominee_Params,
	TournamentV2Controller_kickNominee_Body,
	TournamentV2Controller_kickNominee_Response,
	TournamentV2Controller_getMainTournaments_Params,
	TournamentV2Controller_getMainTournaments_Response,
	TournamentV2Controller_getMainTournaments_RO,
	TournamentV2Controller_getParticipatedTournaments_Params,
	TournamentV2Controller_getParticipatedTournaments_Response,
	TournamentV2Controller_getParticipatedTournaments_RO,
	TournamentV2Controller_getCreatedTournaments_Params,
	TournamentV2Controller_getCreatedTournaments_Response,
	TournamentV2Controller_getCreatedTournaments_RO,
	TournamentV2Controller_getLiveTournamentMatch_Params,
	TournamentV2Controller_getLiveTournamentMatch_Response,
	TournamentV2Controller_getLiveTournamentMatch_RO,
	TournamentV2Controller_getParticipableTournaments_Params,
	TournamentV2Controller_getParticipableTournaments_Response,
	TournamentV2Controller_getParticipableTournaments_RO,
	TournamentV2Controller_getSpecificStatusTournaments_Params,
	TournamentV2Controller_getSpecificStatusTournaments_Response,
	TournamentV2Controller_getSpecificStatusTournaments_RO,
	TournamentV2Controller_getFinishedTournamentDetail_Params,
	TournamentV2Controller_getFinishedTournamentDetail_Response,
	TournamentV2Controller_getFinishedTournamentDetail_RO,
	TournamentV2Controller_getRecommendedTournament_Params,
	TournamentV2Controller_getRecommendedTournament_Response,
	TournamentV2Controller_getRecommendedTournament_RO,
	TournamentV2Controller_getTournamentDetail_Params,
	TournamentV2Controller_getTournamentDetail_Response,
	TournamentV2Controller_getTournamentDetail_RO,
	TournamentV2Controller_getTournamentTryoutRanking_Params,
	TournamentV2Controller_getTournamentTryoutRanking_Response,
	TournamentV2Controller_getTournamentTryoutRanking_RO,
	TournamentV2Controller_getTournamentStatus_Params,
	TournamentV2Controller_getTournamentStatus_Response,
	TournamentV2Controller_getTournamentStatus_RO,
	TournamentV2Controller_getActivityInbox_Params,
	TournamentV2Controller_getActivityInbox_Response,
	TournamentV2Controller_getActivityInbox_RO,
	TournamentV2Controller_getGameInboxes_Params,
	TournamentV2Controller_getGameInboxes_Response,
	TournamentV2Controller_getGameInboxes_RO,
	TournamentV2Controller_checkParentConsent_Params,
	TournamentV2Controller_checkParentConsent_Response,
	TournamentV2Controller_checkParentConsent_RO,
	TournamentV2Controller_parentConsent_Params,
	TournamentV2Controller_parentConsent_Body,
	TournamentV2Controller_parentConsent_Response,
	TournamentV2Controller_parentConsent_RO,
	TournamentV2Controller_shareTournament_Params,
	TournamentV2Controller_shareTournament_Response,
	TournamentV2Controller_shareTournament_RO,
	TournamentV2Controller_deleteTournament_Params,
	TournamentV2Controller_deleteTournament_Response,
	TournamentV2Controller_getParticipatedTournamentsInfo_Params,
	TournamentV2Controller_getParticipatedTournamentsInfo_Response,
	TournamentV2Controller_getParticipatedTournamentsInfo_RO,
	TournamentV2Controller_getCreatedTournamentsInfo_Params,
	TournamentV2Controller_getCreatedTournamentsInfo_Response,
	TournamentV2Controller_getCreatedTournamentsInfo_RO,
	TournamentV2Controller_getUserCreatedMainTournaments_Params,
	TournamentV2Controller_getUserCreatedMainTournaments_Response,
	TournamentV2Controller_getUserCreatedMainTournaments_RO,
	TournamentV2Controller_getUserCreatedTournamentsDetail_Params,
	TournamentV2Controller_getUserCreatedTournamentsDetail_Response,
	TournamentV2Controller_getUserCreatedTournamentsDetail_RO,
	TournamentV2Controller_getTournamentLiveData_Params,
	TournamentV2Controller_getTournamentLiveData_Response,
	TournamentV2Controller_getTournamentLiveData_RO,
	TournamentV2Controller_internalRoundEnd_Body,
	TournamentV2Controller_internalRoundEnd_Response,
	TournamentV2Controller_internalSearchTournament_Params,
	TournamentV2Controller_internalSearchTournament_Response,
	TournamentV2Controller_internalSearchTournament_RO,
	TournamentV2Controller_internalParticipateStatus_Body,
	TournamentV2Controller_internalParticipateStatus_Response,
	TournamentV2Controller_internalParticipateStatus_RO,
	TournamentV2Controller_createTournamentInboxTask_Body,
	TournamentV2Controller_createTournamentInboxTask_Response,
	TournamentV2Controller_modifyTournamentStatusTask_Body,
	TournamentV2Controller_modifyTournamentStatusTask_Response,
	TournamentV2Controller_tournamentRegisterEndTask_Body,
	TournamentV2Controller_tournamentRegisterEndTask_Response,
	TournamentV2Controller_aggregateTournamentTryoutRankTask_Body,
	TournamentV2Controller_aggregateTournamentTryoutRankTask_Response,
	TournamentV2Controller_selectNomineesTask_Body,
	TournamentV2Controller_selectNomineesTask_Response,
	TournamentV2Controller_matchTournamentTask_Body,
	TournamentV2Controller_matchTournamentTask_Response,
	TournamentV2Controller_intermediateScheduler_Body,
	TournamentV2Controller_intermediateScheduler_Response,
	TournamentV2Controller_createCashTournamentTool_Body,
	TournamentV2Controller_createCashTournamentTool_Response,
	TournamentV2Controller_createCasualTournamentTool_Body,
	TournamentV2Controller_createCasualTournamentTool_Response,
	TournamentV2Controller_deleteTournamentTool_Params,
	TournamentV2Controller_deleteTournamentTool_Response,
	TournamentV2Controller_tournamentDebugTemp_Body,
	TournamentV2Controller_tournamentDebugTemp_Response,
	TournamentV2Controller_createFastCashTournamentTool_Body,
	TournamentV2Controller_createFastCashTournamentTool_Response,
} from '@/domains/content/types/validated';

// openapi-fetch HTTP 메서드들 destructuring (싱글톤 인스턴스)
const { GET, POST, PUT, PATCH, DELETE } = contentFetcher;

/**
 * signedurl 등록
 */
export const createV2TournamentSignedurl = async (
	params: TournamentV2Controller_getSignedUrl_Params,
	body: TournamentV2Controller_getSignedUrl_Body
) => {
	return handleAPIResponse<TournamentV2Controller_getSignedUrl_Response>(
		POST('/v2/tournament/signedurl', {
			params,
			body,
		})
	);
};

/**
 * hold 등록
 */
export const createV2TournamentHold = async (
	params: TournamentV2Controller_holdTournament_Params,
	body: TournamentV2Controller_holdTournament_Body
) => {
	return handleAPIResponse<TournamentV2Controller_holdTournament_Response>(
		POST('/v2/tournament/hold', {
			params,
			body,
		})
	);
};

/**
 * apply 등록
 */
export const createV2TournamentHoldApply = async (
	params: TournamentV2Controller_applyHoldTournament_Params,
	body: TournamentV2Controller_applyHoldTournament_Body
) => {
	return handleAPIResponse<TournamentV2Controller_applyHoldTournament_Response>(
		POST('/v2/tournament/hold/apply', {
			params,
			body,
		})
	);
};

/**
 * applied 조회
 */
export const fetchV2TournamentApplied = async (params: TournamentV2Controller_getAppliedTournaments_Params) => {
	return handleAPIResponse<TournamentV2Controller_getAppliedTournaments_Response>(
		GET('/v2/tournament/applied', {
			params,
		})
	);
};

/**
 * my 조회
 */
export const fetchV2TournamentSetupMy = async (params: TournamentV2Controller_getMySetupTournaments_Params) => {
	return handleAPIResponse<TournamentV2Controller_getMySetupTournaments_Response>(
		GET('/v2/tournament/setup/my', {
			params,
		})
	);
};

/**
 * my 조회
 */
export const fetchV2TournamentProgressMy = async (params: TournamentV2Controller_getMyProgressTournaments_Params) => {
	return handleAPIResponse<TournamentV2Controller_getMyProgressTournaments_Response>(
		GET('/v2/tournament/progress/my', {
			params,
		})
	);
};

/**
 * my 조회
 */
export const fetchV2TournamentFinishedMy = async (params: TournamentV2Controller_getMyFinishedTournaments_Params) => {
	return handleAPIResponse<TournamentV2Controller_getMyFinishedTournaments_Response>(
		GET('/v2/tournament/finished/my', {
			params,
		})
	);
};

/**
 * incomplete 조회
 */
export const fetchV2TournamentIdDetailIncomplete = async (
	params: TournamentV2Controller_getIncompleteTournamentDetail_Params
) => {
	return handleAPIResponse<TournamentV2Controller_getIncompleteTournamentDetail_Response>(
		GET('/v2/tournament/{tournamentId}/detail/incomplete', {
			params,
		})
	);
};

/**
 * complete 수정
 */
export const modifyV2TournamentSetupComplete = async (
	params: TournamentV2Controller_completeSetupTournament_Params,
	body: TournamentV2Controller_completeSetupTournament_Body
) => {
	return handleAPIResponse<TournamentV2Controller_completeSetupTournament_Response>(
		PATCH('/v2/tournament/setup/complete', {
			params,
			body,
		})
	);
};

/**
 * web 조회
 */
export const fetchV2TournamentIdDancesWeb = async (params: TournamentV2Controller_getTournamentDancesForWeb_Params) => {
	return handleAPIResponse<TournamentV2Controller_getTournamentDancesForWeb_Response>(
		GET('/v2/tournament/{tournamentId}/dances/web', {
			params,
		})
	);
};

/**
 * localizations 조회
 */
export const fetchV2TournamentIdLocalizations = async (
	params: TournamentV2Controller_getTournamentLocalizations_Params
) => {
	return handleAPIResponse<TournamentV2Controller_getTournamentLocalizations_Response>(
		GET('/v2/tournament/{tournamentId}/localizations', {
			params,
		})
	);
};

/**
 * list 조회
 */
export const fetchV2TournamentBannerList = async (params: TournamentV2Controller_getTournamentBanners_Params) => {
	return handleAPIResponse<TournamentV2Controller_getTournamentBanners_Response>(
		GET('/v2/tournament/banner/list', {
			params,
		})
	);
};

/**
 * statistics 조회
 */
export const fetchV2TournamentIdFilterStatistics = async (
	params: TournamentV2Controller_getUserFilterStatistics_Params
) => {
	return handleAPIResponse<TournamentV2Controller_getUserFilterStatistics_Response>(
		GET('/v2/tournament/{tournamentId}/filter/statistics', {
			params,
		})
	);
};

/**
 * register 조회
 */
export const fetchV2TournamentIdManageRegister = async (
	params: TournamentV2Controller_getManageRegisterTournament_Params
) => {
	return handleAPIResponse<TournamentV2Controller_getManageRegisterTournament_Response>(
		GET('/v2/tournament/{tournamentId}/manage/register', {
			params,
		})
	);
};

/**
 * qualifier 조회
 */
export const fetchV2TournamentIdManageQualifier = async (
	params: TournamentV2Controller_getManageQaulifierTournament_Params
) => {
	return handleAPIResponse<TournamentV2Controller_getManageQaulifierTournament_Response>(
		GET('/v2/tournament/{tournamentId}/manage/qualifier', {
			params,
		})
	);
};

/**
 * selecting 조회
 */
export const fetchV2TournamentIdManageSelecting = async (
	params: TournamentV2Controller_getManageSelectingTournament_Params
) => {
	return handleAPIResponse<TournamentV2Controller_getManageSelectingTournament_Response>(
		GET('/v2/tournament/{tournamentId}/manage/selecting', {
			params,
		})
	);
};

/**
 * none 조회
 */
export const fetchV2TournamentIdManageSelectingNone = async (
	params: TournamentV2Controller_getManageSelectingNoneTournament_Params
) => {
	return handleAPIResponse<TournamentV2Controller_getManageSelectingNoneTournament_Response>(
		GET('/v2/tournament/{tournamentId}/manage/selecting/none', {
			params,
		})
	);
};

/**
 * selected 조회
 */
export const fetchV2TournamentIdManageSelectingSelected = async (
	params: TournamentV2Controller_getManageSelectingSelectedTournament_Params
) => {
	return handleAPIResponse<TournamentV2Controller_getManageSelectingSelectedTournament_Response>(
		GET('/v2/tournament/{tournamentId}/manage/selecting/selected', {
			params,
		})
	);
};

/**
 * matched 조회
 */
export const fetchV2TournamentIdManageSelectingMatched = async (
	params: TournamentV2Controller_getManageSelectingMatchedTournament_Params
) => {
	return handleAPIResponse<TournamentV2Controller_getManageSelectingMatchedTournament_Response>(
		GET('/v2/tournament/{tournamentId}/manage/selecting/matched', {
			params,
		})
	);
};

/**
 * selection 등록
 */
export const createV2TournamentSelection = async (
	params: TournamentV2Controller_selectNominees_Params,
	body: TournamentV2Controller_selectNominees_Body
) => {
	return handleAPIResponse<TournamentV2Controller_selectNominees_Response>(
		POST('/v2/tournament/selection', {
			params,
			body,
		})
	);
};

/**
 * match 등록
 */
export const createV2TournamentMatch = async (
	params: TournamentV2Controller_matchTournament_Params,
	body: TournamentV2Controller_matchTournament_Body
) => {
	return handleAPIResponse<TournamentV2Controller_matchTournament_Response>(
		POST('/v2/tournament/match', {
			params,
			body,
		})
	);
};

/**
 * prematch 조회
 */
export const fetchV2TournamentIdManagePrematch = async (
	params: TournamentV2Controller_getManagePrematchTournament_Params
) => {
	return handleAPIResponse<TournamentV2Controller_getManagePrematchTournament_Response>(
		GET('/v2/tournament/{tournamentId}/manage/prematch', {
			params,
		})
	);
};

/**
 * live 조회
 */
export const fetchV2TournamentIdManageLive = async (params: TournamentV2Controller_getManageLiveTournament_Params) => {
	return handleAPIResponse<TournamentV2Controller_getManageLiveTournament_Response>(
		GET('/v2/tournament/{tournamentId}/manage/live', {
			params,
		})
	);
};

/**
 * finished 조회
 */
export const fetchV2TournamentIdManageFinished = async (
	params: TournamentV2Controller_getManageFinishedTournament_Params
) => {
	return handleAPIResponse<TournamentV2Controller_getManageFinishedTournament_Response>(
		GET('/v2/tournament/{tournamentId}/manage/finished', {
			params,
		})
	);
};

/**
 * dance 등록
 */
export const createV2TournamentUpcommingDance = async (
	params: TournamentV2Controller_mappingUpcommingTournamentDance_Params,
	body: TournamentV2Controller_mappingUpcommingTournamentDance_Body
) => {
	return handleAPIResponse<TournamentV2Controller_mappingUpcommingTournamentDance_Response>(
		POST('/v2/tournament/upcomming/dance', {
			params,
			body,
		})
	);
};

/**
 * notification 등록
 */
export const createV2TournamentRegisterNotification = async (
	params: TournamentV2Controller_registerNotification_Params,
	body: TournamentV2Controller_registerNotification_Body
) => {
	return handleAPIResponse<TournamentV2Controller_registerNotification_Response>(
		POST('/v2/tournament/register/notification', {
			params,
			body,
		})
	);
};

/**
 * status 조회
 */
export const fetchV2TournamentIdRegisterNotificationStatus = async (
	params: TournamentV2Controller_getRegisterNotificationStatus_Params
) => {
	return handleAPIResponse<TournamentV2Controller_getRegisterNotificationStatus_Response>(
		GET('/v2/tournament/{tournamentId}/register/notification/status', {
			params,
		})
	);
};

/**
 * join 등록
 */
export const createV2TournamentJoin = async (
	params: TournamentV2Controller_joinTournament_Params,
	body: TournamentV2Controller_joinTournament_Body
) => {
	return handleAPIResponse<TournamentV2Controller_joinTournament_Response>(
		POST('/v2/tournament/join', {
			params,
			body,
		})
	);
};

/**
 * cancel 등록
 */
export const createV2TournamentJoinCancel = async (
	params: TournamentV2Controller_cancelJoinTournament_Params,
	body: TournamentV2Controller_cancelJoinTournament_Body
) => {
	return handleAPIResponse<TournamentV2Controller_cancelJoinTournament_Response>(
		POST('/v2/tournament/join/cancel', {
			params,
			body,
		})
	);
};

/**
 * apply 등록
 */
export const createV2TournamentApply = async (
	params: TournamentV2Controller_applyTournament_Params,
	body: TournamentV2Controller_applyTournament_Body
) => {
	return handleAPIResponse<TournamentV2Controller_applyTournament_Response>(
		POST('/v2/tournament/apply', {
			params,
			body,
		})
	);
};

/**
 * cancel 등록
 */
export const createV2TournamentApplyCancel = async (
	params: TournamentV2Controller_cancelApplyTournament_Params,
	body: TournamentV2Controller_cancelApplyTournament_Body
) => {
	return handleAPIResponse<TournamentV2Controller_cancelApplyTournament_Response>(
		POST('/v2/tournament/apply/cancel', {
			params,
			body,
		})
	);
};

/**
 * participants 조회
 */
export const fetchV2TournamentIdParticipants = async (
	params: TournamentV2Controller_getTournamentParticipants_Params
) => {
	return handleAPIResponse<TournamentV2Controller_getTournamentParticipants_Response>(
		GET('/v2/tournament/{tournamentId}/participants', {
			params,
		})
	);
};

/**
 * applicants 조회
 */
export const fetchV2TournamentIdApplicants = async (params: TournamentV2Controller_getTournamentApplicants_Params) => {
	return handleAPIResponse<TournamentV2Controller_getTournamentApplicants_Response>(
		GET('/v2/tournament/{tournamentId}/applicants', {
			params,
		})
	);
};

/**
 * nominees 조회
 */
export const fetchV2TournamentIdNominees = async (params: TournamentV2Controller_getTournamentNominees_Params) => {
	return handleAPIResponse<TournamentV2Controller_getTournamentNominees_Response>(
		GET('/v2/tournament/{tournamentId}/nominees', {
			params,
		})
	);
};

/**
 * participants 조회
 */
export const fetchV2TournamentIdRoundIdParticipants = async (
	params: TournamentV2Controller_getRoundParticipants_Params
) => {
	return handleAPIResponse<TournamentV2Controller_getRoundParticipants_Response>(
		GET('/v2/tournament/{tournamentId}/round/{roundId}/participants', {
			params,
		})
	);
};

/**
 * matches 조회
 */
export const fetchV2TournamentIdRoundIdMatches = async (params: TournamentV2Controller_getRoundMatches_Params) => {
	return handleAPIResponse<TournamentV2Controller_getRoundMatches_Response>(
		GET('/v2/tournament/{tournamentId}/round/{roundId}/matches', {
			params,
		})
	);
};

/**
 * rounds 조회
 */
export const fetchV2TournamentIdRounds = async (params: TournamentV2Controller_getTournamentRounds_Params) => {
	return handleAPIResponse<TournamentV2Controller_getTournamentRounds_Response>(
		GET('/v2/tournament/{tournamentId}/rounds', {
			params,
		})
	);
};

/**
 * dances 조회
 */
export const fetchV2TournamentIdDances = async (params: TournamentV2Controller_getTournamentDances_Params) => {
	return handleAPIResponse<TournamentV2Controller_getTournamentDances_Response>(
		GET('/v2/tournament/{tournamentId}/dances', {
			params,
		})
	);
};

/**
 * nations 조회
 */
export const fetchV2TournamentIdNations = async (params: TournamentV2Controller_getTournamentNations_Params) => {
	return handleAPIResponse<TournamentV2Controller_getTournamentNations_Response>(
		GET('/v2/tournament/{tournamentId}/nations', {
			params,
		})
	);
};

/**
 * process 수정
 */
export const modifyV2TournamentApplicantProcess = async (
	params: TournamentV2Controller_processApplicant_Params,
	body: TournamentV2Controller_processApplicant_Body
) => {
	return handleAPIResponse<TournamentV2Controller_processApplicant_Response>(
		PATCH('/v2/tournament/applicant/process', {
			params,
			body,
		})
	);
};

/**
 * invite 등록
 */
export const createV2TournamentInvite = async (
	params: TournamentV2Controller_inviteTournament_Params,
	body: TournamentV2Controller_inviteTournament_Body
) => {
	return handleAPIResponse<TournamentV2Controller_inviteTournament_Response>(
		POST('/v2/tournament/invite', {
			params,
			body,
		})
	);
};

/**
 * invite 수정
 */
export const modifyV2TournamentInvite = async (
	params: TournamentV2Controller_modifyTournamentInvite_Params,
	body: TournamentV2Controller_modifyTournamentInvite_Body
) => {
	return handleAPIResponse<TournamentV2Controller_modifyTournamentInvite_Response>(
		PATCH('/v2/tournament/invite', {
			params,
			body,
		})
	);
};

/**
 * invites 조회
 */
export const fetchV2TournamentIdInvites = async (params: TournamentV2Controller_getTournamentInvites_Params) => {
	return handleAPIResponse<TournamentV2Controller_getTournamentInvites_Response>(
		GET('/v2/tournament/{tournamentId}/invites', {
			params,
		})
	);
};

/**
 * cancel 수정
 */
export const modifyV2TournamentInviteCancel = async (
	params: TournamentV2Controller_cancelTournamentInvite_Params,
	body: TournamentV2Controller_cancelTournamentInvite_Body
) => {
	return handleAPIResponse<TournamentV2Controller_cancelTournamentInvite_Response>(
		PATCH('/v2/tournament/invite/cancel', {
			params,
			body,
		})
	);
};

/**
 * kick 등록
 */
export const createV2TournamentParticipantKick = async (
	params: TournamentV2Controller_kickParticipant_Params,
	body: TournamentV2Controller_kickParticipant_Body
) => {
	return handleAPIResponse<TournamentV2Controller_kickParticipant_Response>(
		POST('/v2/tournament/participant/kick', {
			params,
			body,
		})
	);
};

/**
 * kick 등록
 */
export const createV2TournamentNomineeKick = async (
	params: TournamentV2Controller_kickNominee_Params,
	body: TournamentV2Controller_kickNominee_Body
) => {
	return handleAPIResponse<TournamentV2Controller_kickNominee_Response>(
		POST('/v2/tournament/nominee/kick', {
			params,
			body,
		})
	);
};

/**
 * main 조회
 */
export const fetchV2TournamentMain = async (params: TournamentV2Controller_getMainTournaments_Params) => {
	return handleAPIResponse<TournamentV2Controller_getMainTournaments_Response>(
		GET('/v2/tournament/main', {
			params,
		})
	);
};

/**
 * participated 조회
 */
export const fetchV2TournamentParticipated = async (
	params: TournamentV2Controller_getParticipatedTournaments_Params
) => {
	return handleAPIResponse<TournamentV2Controller_getParticipatedTournaments_Response>(
		GET('/v2/tournament/participated', {
			params,
		})
	);
};

/**
 * created 조회
 */
export const fetchV2TournamentCreated = async (params: TournamentV2Controller_getCreatedTournaments_Params) => {
	return handleAPIResponse<TournamentV2Controller_getCreatedTournaments_Response>(
		GET('/v2/tournament/created', {
			params,
		})
	);
};

/**
 * match 조회
 */
export const fetchV2TournamentLiveMatch = async (params: TournamentV2Controller_getLiveTournamentMatch_Params) => {
	return handleAPIResponse<TournamentV2Controller_getLiveTournamentMatch_Response>(
		GET('/v2/tournament/live/match', {
			params,
		})
	);
};

/**
 * participable 조회
 */
export const fetchV2TournamentParticipable = async (
	params: TournamentV2Controller_getParticipableTournaments_Params
) => {
	return handleAPIResponse<TournamentV2Controller_getParticipableTournaments_Response>(
		GET('/v2/tournament/participable', {
			params,
		})
	);
};

/**
 * status 조회
 */
export const fetchV2TournamentSpecificStatus = async (
	params: TournamentV2Controller_getSpecificStatusTournaments_Params
) => {
	return handleAPIResponse<TournamentV2Controller_getSpecificStatusTournaments_Response>(
		GET('/v2/tournament/specific/status', {
			params,
		})
	);
};

/**
 * detail 조회
 */
export const fetchV2TournamentFinishedDetail = async (
	params: TournamentV2Controller_getFinishedTournamentDetail_Params
) => {
	return handleAPIResponse<TournamentV2Controller_getFinishedTournamentDetail_Response>(
		GET('/v2/tournament/finished/detail', {
			params,
		})
	);
};

/**
 * recommend 조회
 */
export const fetchV2TournamentRecommend = async (params: TournamentV2Controller_getRecommendedTournament_Params) => {
	return handleAPIResponse<TournamentV2Controller_getRecommendedTournament_Response>(
		GET('/v2/tournament/recommend', {
			params,
		})
	);
};

/**
 * detail 조회
 */
export const fetchV2TournamentIdDetail = async (params: TournamentV2Controller_getTournamentDetail_Params) => {
	return handleAPIResponse<TournamentV2Controller_getTournamentDetail_Response>(
		GET('/v2/tournament/{tournamentId}/detail', {
			params,
		})
	);
};

/**
 * rank 조회
 */
export const fetchV2TournamentIdTryoutRank = async (
	params: TournamentV2Controller_getTournamentTryoutRanking_Params
) => {
	return handleAPIResponse<TournamentV2Controller_getTournamentTryoutRanking_Response>(
		GET('/v2/tournament/{tournamentId}/tryout/rank', {
			params,
		})
	);
};

/**
 * status 조회
 */
export const fetchV2TournamentInboxStatus = async (params: TournamentV2Controller_getTournamentStatus_Params) => {
	return handleAPIResponse<TournamentV2Controller_getTournamentStatus_Response>(
		GET('/v2/tournament/inbox/status', {
			params,
		})
	);
};

/**
 * inboxes 조회
 */
export const fetchV2TournamentActivityInboxes = async (params: TournamentV2Controller_getActivityInbox_Params) => {
	return handleAPIResponse<TournamentV2Controller_getActivityInbox_Response>(
		GET('/v2/tournament/activity/inboxes', {
			params,
		})
	);
};

/**
 * inboxes 조회
 */
export const fetchV2TournamentGameInboxes = async (params: TournamentV2Controller_getGameInboxes_Params) => {
	return handleAPIResponse<TournamentV2Controller_getGameInboxes_Response>(
		GET('/v2/tournament/game/inboxes', {
			params,
		})
	);
};

/**
 * consent 조회
 */
export const fetchV2TournamentParentConsent = async (params: TournamentV2Controller_checkParentConsent_Params) => {
	return handleAPIResponse<TournamentV2Controller_checkParentConsent_Response>(
		GET('/v2/tournament/parent/consent', {
			params,
		})
	);
};

/**
 * consent 등록
 */
export const createV2TournamentParentConsent = async (
	params: TournamentV2Controller_parentConsent_Params,
	body: TournamentV2Controller_parentConsent_Body
) => {
	return handleAPIResponse<TournamentV2Controller_parentConsent_Response>(
		POST('/v2/tournament/parent/consent', {
			params,
			body,
		})
	);
};

/**
 * dynamiclink 조회
 */
export const fetchV2TournamentIdDynamiclink = async (params: TournamentV2Controller_shareTournament_Params) => {
	return handleAPIResponse<TournamentV2Controller_shareTournament_Response>(
		GET('/v2/tournament/{tournamentId}/dynamiclink', {
			params,
		})
	);
};

/**
 * v2 삭제
 */
export const removeV2TournamentId = async (params: TournamentV2Controller_deleteTournament_Params) => {
	return handleAPIResponse<TournamentV2Controller_deleteTournament_Response>(
		DELETE('/v2/tournament/{tournamentId}', {
			params,
		})
	);
};

/**
 * v2 조회
 */
export const fetchV2TournamentParticipationsUserId = async (
	params: TournamentV2Controller_getParticipatedTournamentsInfo_Params
) => {
	return handleAPIResponse<TournamentV2Controller_getParticipatedTournamentsInfo_Response>(
		GET('/v2/tournament/participations/user/{userId}', {
			params,
		})
	);
};

/**
 * v2 조회
 */
export const fetchV2TournamentCreatedSimpleUserId = async (
	params: TournamentV2Controller_getCreatedTournamentsInfo_Params
) => {
	return handleAPIResponse<TournamentV2Controller_getCreatedTournamentsInfo_Response>(
		GET('/v2/tournament/created/simple/user/{userId}', {
			params,
		})
	);
};

/**
 * v2 조회
 */
export const fetchV2TournamentCreatedMainUserId = async (
	params: TournamentV2Controller_getUserCreatedMainTournaments_Params
) => {
	return handleAPIResponse<TournamentV2Controller_getUserCreatedMainTournaments_Response>(
		GET('/v2/tournament/created/main/user/{userId}', {
			params,
		})
	);
};

/**
 * v2 조회
 */
export const fetchV2TournamentCreatedDetailUserId = async (
	params: TournamentV2Controller_getUserCreatedTournamentsDetail_Params
) => {
	return handleAPIResponse<TournamentV2Controller_getUserCreatedTournamentsDetail_Response>(
		GET('/v2/tournament/created/detail/user/{userId}', {
			params,
		})
	);
};

/**
 * data 조회
 */
export const fetchV2TournamentIdLiveData = async (params: TournamentV2Controller_getTournamentLiveData_Params) => {
	return handleAPIResponse<TournamentV2Controller_getTournamentLiveData_Response>(
		GET('/v2/tournament/{tournamentId}/live/data', {
			params,
		})
	);
};

/**
 * end 등록
 */
export const createV2TournamentInternalRoundEnd = async (body: TournamentV2Controller_internalRoundEnd_Body) => {
	return handleAPIResponse<TournamentV2Controller_internalRoundEnd_Response>(
		POST('/v2/tournament/internal/round/end', {
			body,
		})
	);
};

/**
 * search 조회
 */
export const fetchV2TournamentInternalSearch = async (
	params: TournamentV2Controller_internalSearchTournament_Params
) => {
	return handleAPIResponse<TournamentV2Controller_internalSearchTournament_Response>(
		GET('/v2/tournament/internal/search', {
			params,
		})
	);
};

/**
 * status 등록
 */
export const createV2TournamentInternalParticipateStatus = async (
	body: TournamentV2Controller_internalParticipateStatus_Body
) => {
	return handleAPIResponse<TournamentV2Controller_internalParticipateStatus_Response>(
		POST('/v2/tournament/internal/participate/status', {
			body,
		})
	);
};

/**
 * inbox 등록
 */
export const createV2TournamentTaskInbox = async (body: TournamentV2Controller_createTournamentInboxTask_Body) => {
	return handleAPIResponse<TournamentV2Controller_createTournamentInboxTask_Response>(
		POST('/v2/tournament/task/inbox', {
			body,
		})
	);
};

/**
 * status 수정
 */
export const modifyV2TournamentTaskStatus = async (body: TournamentV2Controller_modifyTournamentStatusTask_Body) => {
	return handleAPIResponse<TournamentV2Controller_modifyTournamentStatusTask_Response>(
		PATCH('/v2/tournament/task/status', {
			body,
		})
	);
};

/**
 * end 등록
 */
export const createV2TournamentTaskRegisterEnd = async (
	body: TournamentV2Controller_tournamentRegisterEndTask_Body
) => {
	return handleAPIResponse<TournamentV2Controller_tournamentRegisterEndTask_Response>(
		POST('/v2/tournament/task/register/end', {
			body,
		})
	);
};

/**
 * rank 등록
 */
export const createV2TournamentTaskAggregateTryoutRank = async (
	body: TournamentV2Controller_aggregateTournamentTryoutRankTask_Body
) => {
	return handleAPIResponse<TournamentV2Controller_aggregateTournamentTryoutRankTask_Response>(
		POST('/v2/tournament/task/aggregate/tryout/rank', {
			body,
		})
	);
};

/**
 * selection 등록
 */
export const createV2TournamentTaskSelection = async (body: TournamentV2Controller_selectNomineesTask_Body) => {
	return handleAPIResponse<TournamentV2Controller_selectNomineesTask_Response>(
		POST('/v2/tournament/task/selection', {
			body,
		})
	);
};

/**
 * match 등록
 */
export const createV2TournamentTaskMatch = async (body: TournamentV2Controller_matchTournamentTask_Body) => {
	return handleAPIResponse<TournamentV2Controller_matchTournamentTask_Response>(
		POST('/v2/tournament/task/match', {
			body,
		})
	);
};

/**
 * scheduler 등록
 */
export const createV2TournamentTaskScheduler = async (body: TournamentV2Controller_intermediateScheduler_Body) => {
	return handleAPIResponse<TournamentV2Controller_intermediateScheduler_Response>(
		POST('/v2/tournament/task/scheduler', {
			body,
		})
	);
};

/**
 * cash 등록
 */
export const createV2TournamentToolCash = async (body: TournamentV2Controller_createCashTournamentTool_Body) => {
	return handleAPIResponse<TournamentV2Controller_createCashTournamentTool_Response>(
		POST('/v2/tournament/tool/cash', {
			body,
		})
	);
};

/**
 * casual 등록
 */
export const createV2TournamentToolCasual = async (body: TournamentV2Controller_createCasualTournamentTool_Body) => {
	return handleAPIResponse<TournamentV2Controller_createCasualTournamentTool_Response>(
		POST('/v2/tournament/tool/casual', {
			body,
		})
	);
};

/**
 * v2 삭제
 */
export const removeV2TournamentToolTournamentId = async (
	params: TournamentV2Controller_deleteTournamentTool_Params
) => {
	return handleAPIResponse<TournamentV2Controller_deleteTournamentTool_Response>(
		DELETE('/v2/tournament/tool/tournament/{tournamentId}', {
			params,
		})
	);
};

/**
 * temp 등록
 */
export const createV2TournamentDebugTemp = async (body: TournamentV2Controller_tournamentDebugTemp_Body) => {
	return handleAPIResponse<TournamentV2Controller_tournamentDebugTemp_Response>(
		POST('/v2/tournament/debug/temp', {
			body,
		})
	);
};

/**
 * cash 등록
 */
export const createV2TournamentToolFastCash = async (
	body: TournamentV2Controller_createFastCashTournamentTool_Body
) => {
	return handleAPIResponse<TournamentV2Controller_createFastCashTournamentTool_Response>(
		POST('/v2/tournament/tool/fast/cash', {
			body,
		})
	);
};
